import { useState } from 'react';
import { useGetMemberMutation } from '@services/member/member/member.endpoints';
import { Member } from '@services/member/member/member.types';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useDetailsProfileVM = () => {
    const { id } = useParams();
    const [member, setMember] = useState<Member>();

    const [
        getMember,
        {
            isLoading: isGetMemberLoading,
            isUninitialized: isGetMemberUninitialized,
            isError: isGetMemberError,
            isSuccess: isGetMemberSuccess,
            error: getMemberError,
            data: getMemberResponse
        }
    ] = useGetMemberMutation();

    useEffect(() => {
        if (!id) return;
        getMember({ id });
    }, [id]);

    useEffect(() => {
        if (isGetMemberLoading) return;
        if (isGetMemberError) return;
        if (getMemberError) return;

        if (isGetMemberSuccess && getMemberResponse) {
            setMember(getMemberResponse.data);
        }
    }, [isGetMemberError, isGetMemberSuccess, getMemberError, getMemberResponse, isGetMemberLoading]);

    return {
        isLoading: isGetMemberUninitialized || isGetMemberLoading,
        isError: isGetMemberError && !member,
        member
    };
};
